(() => {
  'use strict';
  function initialize(root = document) {
    const stage = root.querySelector('.hero-stage');
    if (stage && !stage.dataset.initialized) {
      stage.dataset.initialized = 'true';
      const slides = [...stage.querySelectorAll('.slide')];
      const dots = [...stage.querySelectorAll('.slide-dot')];
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0, paused = motion.matches || Shopify.designMode, timer, start;
      const pause = stage.querySelector('#pause-slides');
      const schedule = () => {
        clearTimeout(timer);
        if (!paused && slides.length > 1 && stage.isConnected && !document.hidden && !stage.matches(':hover, :focus-within') && !document.querySelector('dialog[open]')) timer = setTimeout(() => show(current + 1), 6500);
      };
      function show(index) {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('active', i === current);
          slide.inert = i !== current;
          slide.setAttribute('aria-hidden', String(i !== current));
          dots[i].classList.toggle('selected', i === current);
          if (i === current) dots[i].setAttribute('aria-current', 'true');
          else dots[i].removeAttribute('aria-current');
        });
        stage.dataset.slide = String(current);
        stage.querySelector('#slide-number').textContent = String(current + 1).padStart(2, '0');
        schedule();
      }
      dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
      stage.querySelector('#previous-slide').addEventListener('click', () => show(current - 1));
      stage.querySelector('#next-slide').addEventListener('click', () => show(current + 1));
      function updatePause() {
        pause.textContent = paused ? '\u25b7' : '\u2161';
        pause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        schedule();
      }
      pause.addEventListener('click', () => { paused = !paused; updatePause(); });
      ['mouseenter', 'mouseleave', 'focusin', 'focusout'].forEach(type => stage.addEventListener(type, () => setTimeout(schedule, 0)));
      document.addEventListener('visibilitychange', schedule);
      motion.addEventListener('change', () => { paused = motion.matches; updatePause(); });
      stage.addEventListener('touchstart', e => { start = { x: e.touches[0].clientX, y: e.touches[0].clientY }; clearTimeout(timer); }, { passive: true });
      stage.addEventListener('touchend', e => {
        if (start) {
          const dx = e.changedTouches[0].clientX - start.x, dy = e.changedTouches[0].clientY - start.y;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) show(current + (dx < 0 ? 1 : -1));
        }
        start = null; schedule();
      }, { passive: true });
      stage.addEventListener('touchcancel', () => { start = null; schedule(); });
      stage.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); show(current + (e.key === 'ArrowRight' ? 1 : -1)); }
      });
      stage.closest('.shopify-section')?.addEventListener('shopify:block:select', e => {
        const index = slides.indexOf(e.target.closest('.slide'));
        if (index >= 0) { paused = true; show(index); updatePause(); }
      });
      updatePause();
    }
    root.querySelectorAll('[data-enhancement]').forEach(element => { element.hidden = false; });
    const catalog = root.querySelector('[data-punchy-catalog]');
    if (catalog && !catalog.dataset.initialized) {
      catalog.dataset.initialized = 'true';
      const cards = [...catalog.querySelectorAll('[data-catalog-card]')];
      catalog.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
        catalog.querySelectorAll('[data-filter]').forEach(tab => {
          tab.classList.toggle('selected', tab === button);
          tab.setAttribute('aria-pressed', String(tab === button));
        });
        cards.forEach(card => { card.hidden = !(button.dataset.filter === 'all' || (button.dataset.filter === 'under100' ? Number(card.dataset.price) < 10000 : card.dataset.category === button.dataset.filter)); });
        catalog.querySelector('#product-count').textContent = `${cards.filter(card => !card.hidden).length} finds`;
      }));
      catalog.querySelector('#product-count').textContent = `${cards.length} finds`;
    }
  }
  initialize();
  document.addEventListener('shopify:section:load', e => initialize(e.target));
  let trigger;
  const closeMenu = () => {
    const nav = document.querySelector('#mobile-nav');
    if (nav) nav.hidden = true;
    document.querySelector('.menu-button')?.setAttribute('aria-expanded', 'false');
  };
  function openDialog(dialog, source) {
    if (!document.querySelector('dialog[open]')) trigger = source;
    document.querySelectorAll('dialog[open]').forEach(item => item.close());
    dialog.showModal();
    document.body.classList.add('modal-open');
  }
  function closeDialog(dialog) {
    dialog.close(); document.body.classList.remove('modal-open');
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  }
  document.addEventListener('click', e => {
    const menu = e.target.closest('.menu-button');
    if (menu) {
      const nav = document.querySelector('#mobile-nav');
      nav.hidden = !nav.hidden; menu.setAttribute('aria-expanded', String(!nav.hidden)); return;
    }
    if (!e.target.closest('.header') || e.target.closest('#mobile-nav a')) closeMenu();
    const close = e.target.closest('[data-close-dialog]');
    if (close) { closeDialog(close.closest('dialog')); return; }
    const finder = e.target.closest('[data-open-finder]');
    if (finder) { openDialog(document.querySelector('#finder-dialog'), finder); return; }
    const quick = e.target.closest('[data-quick]');
    if (quick && !e.ctrlKey && !e.metaKey && !e.shiftKey && e.button === 0) {
      const card = quick.closest('[data-catalog-card]');
      const template = card?.querySelector('template');
      if (!template) return;
      e.preventDefault();
      document.querySelector('#quick-content').replaceChildren(template.content.cloneNode(true));
      openDialog(document.querySelector('#quick-dialog'), quick);
    }
    if (e.target instanceof HTMLDialogElement && !e.target.matches('[data-cart-drawer]')) {
      const rect = e.target.getBoundingClientRect();
      if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) closeDialog(e.target);
    }
  });
  document.addEventListener('cancel', e => {
    if (e.target instanceof HTMLDialogElement && !e.target.matches('[data-cart-drawer]')) { e.preventDefault(); closeDialog(e.target); }
  }, true);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !document.querySelector('dialog[open]')) closeMenu(); });
  matchMedia('(min-width: 761px)').addEventListener('change', closeMenu);
  document.addEventListener('submit', e => {
    if (e.target.id !== 'finder-form') return;
    e.preventDefault();
    const answers = new FormData(e.target);
    const cards = [...document.querySelectorAll('[data-punchy-catalog] [data-catalog-card]')];
    const matches = cards.filter(card => card.dataset.available === 'true' && Number(card.dataset.price) <= Number(answers.get('budget')) && (answers.get('interest') === 'all' || answers.get('interest') === card.dataset.category));
    const results = document.querySelector('#finder-results');
    const heading = document.createElement('p'); heading.className = 'match-heading';
    heading.textContent = matches.length ? `${matches.length} matches from our featured edit.` : 'No available matches. Try another interest or a higher budget.';
    results.replaceChildren(heading);
    matches.forEach(card => {
      const link = document.createElement('a'); link.className = 'match-card'; link.href = card.querySelector('h3 a').href;
      const image = card.querySelector('img')?.cloneNode(true);
      const text = document.createElement('span'), title = document.createElement('strong'), price = document.createElement('small');
      title.textContent = card.querySelector('h3').textContent;
      price.textContent = card.querySelector('.product-price').childNodes[0].textContent.trim();
      text.append(title, price); if (image) link.append(image); link.append(text); results.append(link);
    });
  });
  document.addEventListener('change', e => { if (e.target.closest('#finder-form')) document.querySelector('#finder-results').replaceChildren(); });
})();
